import { render } from "./educationLevel.vue?vue&type=template&id=3b03ed2f&scoped=true"
import script from "./educationLevel.vue?vue&type=script&lang=js"
export * from "./educationLevel.vue?vue&type=script&lang=js"

import "./educationLevel.vue?vue&type=style&index=0&id=3b03ed2f&scoped=true&lang=css"
import "./educationLevel.vue?vue&type=style&index=1&id=3b03ed2f&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b03ed2f"]])

export default __exports__